interface Scripts {
    name: string;
    src: string;
}  
export const ScriptStore: Scripts[] = [
    {name: 'owl', src: 'assets/js/plugins.js'},
    {name: 'main', src: 'assets/js/main.js'},
    {name: 'jquery', src: 'assets/js/jquery.min.js'}
];
